/* Themed dropdown. The OS draws native <select> popups and CSS cannot touch
   them, so this overlays a styled listbox. The original <select> stays in the
   DOM (hidden) so the form posts normally and existing 'change' listeners —
   product -> size mode, delivery -> address — keep working. */
(function () {
  'use strict';
  var OPEN = null;
  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function build(sel) {
    if (sel.dataset.ddReady || sel.multiple || sel.size > 1) return;
    sel.dataset.ddReady = '1';

    var wrap = document.createElement('div');
    wrap.className = 'dd';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);

    var labelEl = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    if (labelEl) {
      btn.setAttribute('aria-label', labelEl.textContent.trim());
      labelEl.addEventListener('click', function (e) { e.preventDefault(); btn.focus(); });
    }

    var list = document.createElement('ul');
    list.className = 'dd__list';
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;
    // (Re)builds the items from the <select>; scripts like the quote form
    // swap a select's options, then fire 'change', which lands in sync().
    function renderList() {
      list.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (opt, i) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.index = i;
        li.textContent = opt.textContent;
        if (opt.disabled) li.setAttribute('aria-disabled', 'true');
        list.appendChild(li);
      });
    }
    renderList();

    sel.setAttribute('aria-hidden', 'true');
    sel.tabIndex = -1;
    wrap.appendChild(btn);
    wrap.appendChild(list);

    function sync() {
      var stale = list.children.length !== sel.options.length ||
        Array.prototype.some.call(sel.options, function (o, i) { return list.children[i].textContent !== o.textContent; });
      if (stale) renderList();
      var o = sel.options[sel.selectedIndex];
      btn.innerHTML = '<span>' + (o ? esc(o.textContent) : '') + '</span>';
      Array.prototype.forEach.call(list.children, function (li) {
        li.setAttribute('aria-selected', +li.dataset.index === sel.selectedIndex ? 'true' : 'false');
      });
    }
    function focusOpt(i) {
      Array.prototype.forEach.call(list.children, function (x) { x.classList.remove('is-focus'); });
      var li = list.children[i];
      if (li) { li.classList.add('is-focus'); li.scrollIntoView({ block: 'nearest' }); }
    }
    function cur() {
      var f = list.querySelector('.is-focus');
      return f ? +f.dataset.index : Math.max(0, sel.selectedIndex);
    }
    function close() {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      if (OPEN === close) OPEN = null;
    }
    function open() {
      if (OPEN && OPEN !== close) OPEN();
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      OPEN = close;
      focusOpt(Math.max(0, sel.selectedIndex));
    }
    function choose(i) {
      var o = sel.options[i];
      if (o && !o.disabled && sel.selectedIndex !== i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync(); close(); btn.focus();
    }

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    btn.addEventListener('keydown', function (e) {
      if (!list.hidden) return;                       // open-state keys handled on wrap
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) {
        e.preventDefault();
        e.stopPropagation();   // don't let the wrapper treat this same keydown as a move
        open();
      }
    });
    wrap.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      var n = list.children.length, i = cur();
      if (e.key === 'ArrowDown')      { e.preventDefault(); focusOpt(Math.min(n - 1, i + 1)); }
      else if (e.key === 'ArrowUp')   { e.preventDefault(); focusOpt(Math.max(0, i - 1)); }
      else if (e.key === 'Home')      { e.preventDefault(); focusOpt(0); }
      else if (e.key === 'End')       { e.preventDefault(); focusOpt(n - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(cur()); }
      else if (e.key === 'Escape')    { e.preventDefault(); close(); btn.focus(); }
      else if (e.key === 'Tab')       { close(); }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('[role="option"]'); if (li) choose(+li.dataset.index);
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('[role="option"]'); if (li) focusOpt(+li.dataset.index);
    });
    sel.addEventListener('change', sync);   // keeps in step if something else sets the value
    sync();
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.form select, .shopbar select'), build);
  }
  document.addEventListener('click', function (e) { if (OPEN && !e.target.closest('.dd.is-open')) OPEN(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
